export default {
  constants:{
    Previous: "Previous",
    Next: "Next",
    Page: "Page",
    viewAll: "View All",
    of: "of",
    size: "Size",
    material: "Material",
    name: "Name",
    email: "Email",
    message: "Message",
    submit: "Submit",
    close: "Close",
    sending: "Sending...",
  },
  alertMessages: {
    successMessageContact: "Your request has been submitted successfully!",
    errorMessageContact: "There was an error submitting your inquiry. Please try again later.",
    serverErrorContact: "Server not reachable. Try again later.",
  },
  navbar: {
    menu: {
      Home: "Home",
      Category: "Category",
      Blog: "Blog",
      AboutUs: "About Us",
      ContactUs: "Contact Us",
    },
  },
  featureHighlights: {
    header: "Your Dream Project In 4 Steps",
    description:
      "Looking To Design Your Dream Art? We Create Beautiful Temples, Statues, And Art Just For You.",
    features: [
      {
        icon: "/assets/featurehighlights/OneToOne.png",
        title: "1. Lets Connect One To One",
      },
      {
        icon: "/assets/featurehighlights/ExploreCatalog.png",
        title: "2. Explore Our Catalog",
      },
      {
        icon: "/assets/featurehighlights/PlaceOrder.png",
        title: "3. Place Order",
      },
      {
        icon: "/assets/featurehighlights/DeliveryInstallation.png",
        title: "4. Delivery & Installation",
      },
      /*{ 
        icon: '/assets/featurehighlights/Continuous_Improvements.png', 
        title: 'Continuous Improvements' 
      },*/
    ],
  },
  HomeCategorySwipper: {
    viewAllCategories: "View All Categories",
    viewAll: "View All",
  },
  HomeClient: {
    completedProjects: "Completed Custom Projects",
    projects: "Projects",
    countries: "Countries",
    yearsExperience: "Years Experience",
    ourClients: "Our Clients",
  },
  footer: {
    address: "Address",
    addressDetails: "Shop 2161, 2nd cross Kajano walo ka rasta, Chandpole bajar, Jaipur, Rajasthan 302001",
    Call: "Call",
    CallValue: "+91 8905046144",
    Email: "Email",
    EmailValue: "harshpandey9079@gmail.com",
    houseOfPandey: "HOUSE OF PANDEY",
    home: "Home",
    category: "Category",
    blog: "Blog",
    aboutUs: "About Us",
    contactUs: "Contact Us",
    quickLinks: "QUICK LINKS",
    howItWorks: "How It Works",
    needHelp: "NEED HELP",
    faqs: "FAQs",
    stores: "Stores",
    callUs: "Call Us",
    EmailUs: "Email Us",
    followUs: "FOLLOW US",
    instagram: "Instagram",
    pinterest: "Pinterest",
    facebook: "Facebook",
    youtube: "YouTube",
    twitter: "Twitter",
    linkedin: "LinkedIn",
    shopName: "Pandey Arts Shop",
    rightsReserved: "All Rights Reserved.",
    workingHours: "Monday to Sunday | 10 am - 8 pm"
  },
  category: {
    productCategory: "Product Category",
    viewAll: "View All",
  },
  products: {
    viewProduct: "View Product",
  },
  productDetails: {
    inStock: "In Stock",
    outOfStock: "Out of Stock",
    relatedProducts: "Related Products",
    share: "Share",
    inquireNow: "Inquire Now For Free Quote",
    whatsappInquiry: "WhatsApp Us For Free Quote",
    sizeMessage: "Customized Size Available As Per Your Need",
    materialMessage: "Customized Material Available As Per Your Need",
    shareProductOn: "Share Product On",
    callUsFree: "Call Us Free",
    emailUsFree: "Email Us Free",
    inquirySuccess: "Your inquiry has been submitted successfully!",
    inquiryError: "There was an error submitting your inquiry. Please try again later.",
  },
  contactUs: {
    ourTeam: "Our Team",
    rajeshPandey: "Rajesh Pandey",
    harshPandey: "Harsh Pandey"
  },
  contactUsForm: {
    talkToExpert: "Talk to Our Expert",
    forFree: "For Free",
    fullName: "Full Name",
    email: "Email",
    phone: "Phone Number",
    city: "City",
    tellUsMessage: "Tell us about yourself",
    homeOwnerMessage: "I am a homeowner looking for a stone art.",
    designerMessage: "I am a interior designer/architect looking for solution for my client.",
    contactUsFree: "Contact Us Free",
  },
  relatedProducts: {
    relatedProducts: "Related Products",
    viewMore: "View More",
    viewDetails: "View Details",
  },
  aboutUs: {
    imageDescription: "Crafting Timeless Stone Artworks with Passion and Precision",
    ourStory: "Our Story",
    ourStoryDetails: "We are passionate artisans dedicated to creating unique stone art that tells a story of tradition, devotion, and timeless elegance. From intricately carved temples and statues to modern stone wall art, every creation is a blend of heritage and craftsmanship.",
    outStoryDetails2: "With decades of experience, our goal is to bring the beauty of natural stone into homes, workplaces, and spiritual spaces across the world.",
    ourMission: "Our Mission",
    ourMissionDetails: "To deliver world-class stone artworks that reflect cultural richness and modern elegance, while keeping craftsmanship alive for future generations.",
    ourVision: "Our Vision",
    ourVisionDetails: "To be the most trusted global name in stone artistry, where every piece narrates a timeless story of art and devotion.",
    whyChooseUs: "Why Choose Us?",
    authenticStone: "Authentic Stone",
    authenticStoneDetails: "We use only the finest quality stone for long-lasting beauty.",
    handcraftedArt: "Handcrafted Art",
    handcraftedArtDetails: "Every creation is hand-carved by skilled artisans with decades of experience.",
    globalReach: "Global Reach",
    globalReachDetails: "From local temples to international projects, our art travels worldwide.",
    jaipurStore: "Pandey Arts Shop",
    storeAddress: "Hno 2161, Pandey Arts India, 2nd cross, Kajane walo ka rasta, Chandpole bajar, Jaipur, Rajasthan 302001",
    storeContactPhone: "Contact: +91 8905046144",
    storeContactEmail: "Email: harshpandey9079@gmail.com",
    storeHours: "Monday to Sunday | 10 am - 8 pm",
    jaipurWarehouse: "Pandey Arts Warehouse",
    warehouseAddress: "Hno 2161, Pandey Arts India, 2nd cross, Kajane walo ka rasta, Chandpole bajar, Jaipur, Rajasthan 302001",
  }
};

